import { app } from 'app/app';
import { MasterLayout } from 'layout/master/main';
import { CompanyHeader } from 'module/companyHeader/main';
import { AppController } from 'app/controller';
import { KeyFactCard } from 'module/keyFactCard/main';
import { mediaQueries } from 'util/mediaQueries';
import { CompanyText } from 'module/companyText/main';
import { EbCompanyMediaItems } from 'module/ebCompanyMediaItems/main';
import { FollowButton } from 'module/followButton/main';
import { EbContactPerson } from 'module/ebContactPerson/main';
import { EbMainLocation } from 'module/ebMainLocation/main';
import { EbJobCard } from 'module/ebJobCard/main';
import { EbCompanyBenefits } from 'module/ebCompanyBenefits/main';
import { EbCategorizedBenefits } from 'module/ebCategorizedBenefits/main';
import { ValuesCard } from 'module/valuesCard/main';
import { MissionBanner } from 'module/missionBanner/main';
import { TeamCardsSlider } from 'module/teamCardsSlider/main';
import { EbCompanyVideo } from 'module/ebCompanyVideo/main';
import { EbCompanySocialMediaFeed } from 'module/ebCompanySocialMediaFeed/main';
import { CompanyRecruiterInquiryModal } from 'module/companyRecruiterInquiryModal/main';
import { EbAccordion } from 'module/ebAccordion/main';
import { CompanyProspect } from 'module/companyProspect/main';
import { user } from 'app/user';
import { userWatchlist } from 'app/userWatchlist';
import { userCompanyFollow } from 'app/userCompanyFollow';
import { MAIL_NEVER, MAIL_WEEKLY } from 'app/mailSubscriptionInterval';
import { trackGa4, sendPageView } from 'util/googleAnalytics';
import { log } from '@karriereat/action-logger';
import { showSnackbar } from 'util/snackbar';
import './styles.scss';

class EmployerBrandingIndex extends AppController {
    domBindings() {
        return {
            employerBranding: '.c-employerBrandingIndex',
            companyHeader: '.m-companyHeader',
            toggleShowMore: '.m-companyText__toggleShowMore',
            companyText: '.m-companyText',
            keyFacts: '.m-keyFactCard',
            followButton: '.c-employerBrandingIndex__followButtonMobile .m-followButton',
            ebCompanyMediaItems: '.m-ebCompanyMediaItems',
            ebContactPerson: '.c-employerBrandingIndex__contactPerson .m-ebContactPerson',
            mainLocation: '.c-employerBrandingIndex__mainLocation .m-ebMainLocation',
            companyBenefits: '.m-ebCompanyBenefits',
            ebCategorizedBenefits: '.m-ebCategorizedBenefits',
            ebJobCards: ['.m-ebJobCard'],
            jobCount: '.c-employerBrandingIndex__jobCardContainer',
            companyValues: '.m-valuesCard',
            missionBanner: '.c-employerBrandingIndex__missionText .m-missionBanner',
            teamCardsSlider: '.m-teamCardsSlider',
            ebCompanyVideo: '.m-ebCompanyVideo',
            ebCompanySocialMediaFeed: '.m-ebCompanySocialMediaFeed',
            companyRecruiterInquiryModal: '.m-companyRecruiterInquiryModal',
            ebAccordion: '.m-ebAccordion',
            jobsWrapper: '.c-employerBrandingIndex__jobsWrapper',
            jobsTitle: '.c-employerBrandingIndex__jobsTitle',
            companyProspect: '.m-companyProspect',
        };
    }

    subs() {
        this.layout = new MasterLayout(document.documentElement);
        if (this.dom.companyHeader) {
            this.companyHeader = new CompanyHeader(this.dom.companyHeader);
        }
        if (this.dom.followButton) {
            this.followButton = new FollowButton(this.dom.followButton);
        }
        if (this.dom.keyFacts) {
            this.keyfact = new KeyFactCard(this.dom.keyFacts);
        }
        if (this.dom.companyText) {
            this.companyText = new CompanyText(this.dom.companyText);
        }
        if (this.dom.ebCompanyMediaItems) {
            this.ebCompanyMediaItems = new EbCompanyMediaItems(this.dom.ebCompanyMediaItems);
        }
        if (this.dom.companyBenefits) {
            this.companyBenefits = new EbCompanyBenefits(this.dom.companyBenefits);
        }
        if (this.dom.ebCategorizedBenefits) {
            this.ebCategorizedBenefits = new EbCategorizedBenefits(this.dom.ebCategorizedBenefits);
        }
        if (this.dom.ebContactPerson) {
            this.ebContactPerson = new EbContactPerson(this.dom.ebContactPerson);
        }
        if (this.dom.mainLocation) {
            this.mainLocation = new EbMainLocation(this.dom.mainLocation);
        }
        if (this.dom.missionBanner) {
            this.missionBanner = new MissionBanner(this.dom.missionBanner);
        }
        if (this.dom.companyValues) {
            this.valuesCard = new ValuesCard(this.dom.companyValues);
        }
        if (this.dom.teamCardsSlider) {
            this.teamCardsSlider = new TeamCardsSlider(this.dom.teamCardsSlider);
        }
        this.ebJobCards = [];
        if (this.dom.ebJobCards) {
            this.dom.ebJobCards.forEach((ebJobCard) => {
                this.ebJobCards.push(new EbJobCard(ebJobCard));
            });
        }
        if (this.dom.ebCompanyVideo) {
            this.companyVideo = new EbCompanyVideo(this.dom.ebCompanyVideo);
        }
        if (this.dom.ebCompanySocialMediaFeed) {
            this.ebCompanySocialMediaFeed = new EbCompanySocialMediaFeed(this.dom.ebCompanySocialMediaFeed);
        }
        if (this.dom.companyRecruiterInquiryModal) {
            this.companyRecruiterInquiryModal = new CompanyRecruiterInquiryModal(this.dom.companyRecruiterInquiryModal);
        }
        if (this.dom.ebAccordion) {
            this.ebAccordion = new EbAccordion(this.dom.ebAccordion);
        }

        if (this.dom.companyProspect) {
            this.companyProspect = new CompanyProspect(this.dom.companyProspect);
        }
    }

    getPropsFromDom() {
        return {
            id: this.dom.employerBranding.getAttribute('data-company-id'),
            brandColor: this.dom.employerBranding.getAttribute('data-slug'),
            productType: this.dom.employerBranding.getAttribute('data-product-type'),
            companyAlarmNotificationInterval:
                parseInt(this.dom.employerBranding.getAttribute('data-companyalarmnotificationinterval'), 10),
            companyId: this.dom.employerBranding.getAttribute('data-company-id'),
            desktopJobs: this.dom.jobCount ? this.dom.jobCount.getAttribute('data-desktop-jobs-count') : null,
            mobileJobs: this.dom.jobCount ? this.dom.jobCount.getAttribute('data-mobile-jobs-count') : null,
            ciColor: this.dom.employerBranding.getAttribute('data-ci-color'),
            ciColorIcons: this.dom.employerBranding.getAttribute('data-ci-color-icons'),
            ciColorIconsOpacity: this.dom.employerBranding.getAttribute('data-ci-color-icons-Opacity'),
            contrastColor: this.dom.employerBranding.getAttribute('data-contrast-color'),
            openJobs: this.dom.jobsWrapper.getAttribute('data-jobs'),
        };
    }

    onPopState(state) {
        if (!state) return; // hashbang fix
        this.toggleLightBoxState();
        sendPageView();
    }

    subsProps() {
        if (this.followButton) {
            this.followButton.updateProps({ id: this.props.id });
        }
    }

    ready() {
        app.events.on('firstUserInteraction', () => this.onFirstUserInteraction());
        this.updateCompanyMediaProps();
        this.trackingOnReadyState();
        this.showMaxJobsOnReadyState();
        this.showJobsTitle();
    }

    toggleLightBoxState() {
        if (this.layout.lightBox.props.active !== false) {
            this.layout.lightBox.closeLightBox();
        } else {
            this.layout.lightBox.openMediaItem(this.layout.lightBox.props.lastSrc);
        }
    }

    updateCompanyMediaProps() {
        if (this.ebCompanyMediaItems) {
            this.layout.lightBox.updateProps({ mediaItems: this.ebCompanyMediaItems.props.mediaItems });
        }
    }

    trackingOnReadyState() {
        if (this.props.productType) {
            trackGa4({
                event: 'company_view',
                view_type: 'Standalone',
                product_type: this.props.productType === 'Arbeitgeberprofil Plus'
                    ? 'Arbeitgeberprofil'
                    : this.props.productType,
                company_id: this.props.companyId ?? null,
            });
        }
    }

    showMaxJobsOnReadyState() {
        const maxItems = mediaQueries.current === 'desktop'
            ? this.props.desktopJobs
            : this.props.mobileJobs;

        this.dom.ebJobCards.forEach((item, index) => {
            if (index < maxItems) {
                item.style.display = 'inherit';
            } else {
                item.style.display = 'none';
            }
        });
    }

    showJobsTitle() {
        if (this.props.openJobs === '0') {
            this.dom.jobsTitle.innerText = 'Aktuell keine offenen Jobs';
            this.dom.jobsWrapper.classList.add('c-employerBrandingIndex__jobPadding');
        }
    }

    subEvents() {
        this.companyHeaderEvents();
        this.companyMediaItemsEvents();
        this.followButtonEvents();
        this.changeCIColorEvents();
        this.contactPersonEvents();
        this.valuesCardEvents();
    }

    onFirstUserInteraction() {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
        this.initHistoryApi();
    }

    companyHeaderEvents() {
        if (this.dom.companyHeader) {
            this.companyHeader.events.on('pushState', () => {
                const props = { ...this.getProps() };
                props.shareModalOpen = true;
                this.pushState(props, document.title, window.location.href);
            });
        }
    }

    companyMediaItemsEvents() {
        if (this.ebCompanyMediaItems) {
            this.ebCompanyMediaItems.events.on('openMediaItem', (context) => {
                this.layout.lightBox.openMediaItemViaClick(context.arguments[0]);
            });

            this.layout.lightBox.events.on('image-view', () => {
                log('company-image-view', {
                    slug: this.props.slug,
                });
            });

            this.layout.events.on('pushState', () => {
                this.pushState(this.getProps(), document.title, window.location.href, false);
            });
        }
    }

    followButtonEvents() {
        if (!user.isLoggedIn()) {
            userWatchlist.events.on('onUnauthorized', (watchlistObject) => {
                this.layout.openLoginModal(watchlistObject.arguments[0].watchlistObject.state, true);
            });
            userCompanyFollow.events.once('onUnauthorized', (followObject) => {
                this.layout.openLoginModal(followObject.arguments[0].companyFollowObject.state, true);
            });
        } else {
            userCompanyFollow.events.on('onAddJob', () => {
                let snackbarText;
                if (this.props.companyAlarmNotificationInterval === MAIL_WEEKLY) {
                    snackbarText = 'Ab sofort erhältst du wöchentlich neue Jobs dieser Firma per E-Mail.';
                } else {
                    snackbarText = 'Ab sofort erhältst du täglich neue Jobs dieser Firma per E-Mail.';
                }

                showSnackbar({
                    text: snackbarText,
                    icon: false,
                    link: '/settings/notifications#c-notificationIndex-companyalarm',
                    linkText: 'Anpassen',
                });
            });
            userCompanyFollow.events.on('onRemoveJob', () => {
                if (this.props.companyAlarmNotificationInterval !== MAIL_NEVER) {
                    showSnackbar({
                        text: 'Du erhältst ab sofort keine Jobs dieser Firma mehr per E-Mail.',
                    });
                }
            });
            userCompanyFollow.events.on('onFollowError', (error) => {
                [].forEach.call(error.arguments[0].errors, (err) => {
                    if (err.meta.company_follow_max_limit) {
                        showSnackbar({
                            text: 'Oje, du hast das Maximum schon erreicht! Um dieser Firma zu folgen, '
                            + 'entfolge einer anderen Firma.',
                            link: '/companyalarm?openAccordion=true',
                            linkText: 'Zum Firmen-Alarm ',
                        });
                    }
                });
            });
        }
    }

    changeCIColorEvents() {
        document.documentElement.style.setProperty('--primary-color', this.props.ciColor);
        document.documentElement.style.setProperty('--contrast-color', this.props.contrastColor);
        document.documentElement.style.setProperty('--contrast-color-icon', this.props.ciColorIcons);
        document.documentElement.style.setProperty('--contrast-color-icon-opacity', this.props.ciColorIconsOpacity);
    }

    contactPersonEvents() {
        if (this.ebContactPerson) {
            this.ebContactPerson.events.on('scrollToSection', () => {
                this.ebContactPerson.dom.el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            });
            this.ebContactPerson.loadCaptcha();

            this.ebContactPerson.events.on('openInquiryModal', (context) => {
                this.companyRecruiterInquiryModal.props = context.arguments[0];
                this.companyRecruiterInquiryModal.updateProps(
                    Object.assign(
                        this.companyRecruiterInquiryModal.getPropsFromDom(),
                        { visible: true, active: true },
                    ),
                    true,
                );
                this.companyRecruiterInquiryModal.loadCaptcha();
                this.layout.addModalStyle(true);
            });
        }

        if (this.companyRecruiterInquiryModal) {
            this.ebContactPerson.events.on('showCompanyRecruiterInquiryToast', () => {
                this.layout.toast.updateProps({
                    active: true,
                    message: 'Deine Nachricht wurde erfolgreich gesendet!',
                    iconSuccess: true,
                    type: 'success',
                }, true);
                this.layout.toast.slideIn();
            });

            this.ebContactPerson.events.on('removeModalStyle', () => {
                this.layout.removeModalStyle(true);
            });

            this.ebContactPerson.events.on('addModalStyle', () => {
                this.layout.addModalStyle(true);
            });
        }
    }

    valuesCardEvents() {
        if (this.valuesCard) {
            this.valuesCard.events.on('scrollToValuesSection', () => {
                this.valuesCard.dom.el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            });
        }
    }
}

app.boot(EmployerBrandingIndex);

if (module.hot) {
    module.hot.accept(module.children, () => {
        // eslint-disable-next-line no-console
        console.log('Rebooting controller due to HMR...');
        app.boot(EmployerBrandingIndex);
    });

    module.hot.accept(() => {});
}
